import React from 'react';
import styles from "./style/Footer.module.css";


function Footer() {
  return (
    <footer className={styles.footerContainer}>
        <div className={styles.footerTextContainer}>
          <p className={styles.footerText}>&copy; Dörtyıldız, 2022. Tüm hakları saklıdır.</p>
        </div>
    </footer>
  );
}

export default Footer;